(function () {
	if (window.__krownProductQtyLimitsReady) return;
	window.__krownProductQtyLimitsReady = true;

	const LIMITS = {
		'9494635053359': {
			max: 20,
			message: 'You can only add up to 20 of this item to your cart.',
		},
	};

	window.__KROWN_PRODUCT_QTY_LIMITS = LIMITS;

	window.__krownGetProductQtyLimit = function (productId) {
		if (!productId) return null;
		const entry = LIMITS[String(productId)];
		const limit = typeof entry === 'object' ? entry.max : entry;
		return Number.isFinite(limit) ? limit : null;
	};

	window.__krownGetProductQtyLimitMessage = function (productId) {
		const entry = LIMITS[String(productId)];
		if (entry == null) return '';
		if (typeof entry === 'object' && entry.message) {
			return entry.message;
		}
		const limit = window.__krownGetProductQtyLimit(productId);
		return limit == null ? '' : `You can only add up to ${limit} of this item to your cart.`;
	};

	window.__krownGetCapTotal = function (ruleMax, stockLimit) {
		const limits = [];
		if (ruleMax != null && ruleMax !== '') {
			const r = parseInt(ruleMax, 10);
			if (Number.isFinite(r) && r >= 0) limits.push(r);
		}
		if (stockLimit != null && stockLimit !== '') {
			const s = parseInt(stockLimit, 10);
			if (Number.isFinite(s) && s >= 0) limits.push(s);
		}
		if (limits.length === 0) return null;
		return Math.min(...limits);
	};

	window.__krownGetAvailabilityMessageCount = function (context) {
		if (context == null) return 0;
		if (typeof context === 'number') {
			const qty = parseInt(context, 10);
			return Number.isFinite(qty) && qty >= 0 ? qty : 0;
		}
		const ruleMax = context.ruleMax ?? context.quantityRuleMax;
		const stockLimit = context.stockLimit ?? context.inventoryQuantity ?? context.inventoryQty;
		const capTotal = window.__krownGetCapTotal(ruleMax, stockLimit);
		if (capTotal != null) return capTotal;
		return 0;
	};

	window.__krownGetAvailabilityAddedMessage = function (contextOrQty) {
		const context =
			typeof contextOrQty === 'object' && contextOrQty !== null
				? contextOrQty
				: typeof contextOrQty === 'number'
					? { stockLimit: contextOrQty }
					: {};
		const qty = window.__krownGetAvailabilityMessageCount(context);
		if (!Number.isFinite(qty) || qty < 0) return '';
		const template =
			(typeof KROWN !== 'undefined' && KROWN.settings?.locales?.products_availability_partial_add) ||
			'Only {{ count }} items were added to your cart due to availability.';
		return template.replace(/\{\{\s*count\s*\}\}/g, String(qty));
	};

	window.__krownGetCartAtCapMessage = function (contextOrStockLimit) {
		const context =
			typeof contextOrStockLimit === 'object' && contextOrStockLimit !== null
				? contextOrStockLimit
				: { stockLimit: contextOrStockLimit };
		return window.__krownGetAvailabilityAddedMessage(context);
	};

	window.__krownResolveStockMessage = function (scenario, context) {
		context = context || {};
		const capContext = {
			ruleMax: context.ruleMax ?? context.quantityRuleMax,
			stockLimit: context.stockLimit ?? context.inventoryQuantity ?? context.inventoryQty,
		};
		if (scenario === 'partial_add' || scenario === 'cart_at_cap') {
			return window.__krownGetCartAtCapMessage(capContext);
		}
		return window.__krownGetAvailabilityAddedMessage(capContext);
	};

	window.__krownIsProductCardContext = function (el) {
		return !!(
			el?.closest?.('[data-js-product-item]') ||
			el?.matches?.('quick-add-to-cart') ||
			el?.closest?.('quick-add-to-cart')
		);
	};

	window.__krownGetRuleMax = function (qtyInput) {
		if (!qtyInput) return null;
		const attr =
			qtyInput.getAttribute?.('data-krown-rule-max') ||
			qtyInput.getAttribute?.('data-rs-rule-max') ||
			qtyInput.getAttribute?.('max');
		if (attr == null || attr === '') return null;
		const parsed = parseInt(attr, 10);
		return Number.isFinite(parsed) ? parsed : null;
	};

	window.__krownGetZeroAddableMessage = async function (productPage, productId, variantId) {
		const stockLimit = window.__krownGetAvailabilityStockLimit(productPage);
		const qtyInput =
			productPage?.querySelector?.('input[name="quantity"]') ||
			productPage?.querySelector?.('.qty-selector');
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		const ruleMax = window.__krownGetRuleMax(qtyInput) ?? hardLimit;
		const isProductCard = window.__krownIsProductCardContext(productPage);

		if (stockLimit != null && variantId) {
			const cartVariantQty = await window.__krownFetchCartQtyForVariant(variantId);
			if (stockLimit - cartVariantQty <= 0) {
				if (cartVariantQty > 0 || isProductCard) {
					return window.__krownResolveStockMessage('cart_at_cap', { ruleMax, stockLimit });
				}
			}
		}

		if (hardLimit != null) {
			const cartProductQty = await window.__krownFetchCartQtyForProduct(productId);
			if (hardLimit - cartProductQty <= 0) {
				if (isProductCard) {
					return window.__krownResolveStockMessage('cart_at_cap', {
						ruleMax: hardLimit,
						stockLimit,
					});
				}
				return window.__krownGetProductQtyLimitMessage(productId);
			}
		}

		if (isProductCard) {
			return window.__krownResolveStockMessage('cart_at_cap', { ruleMax, stockLimit });
		}

		return window.__krownGetProductQtyLimitMessage(productId);
	};

	window.__krownIsGiftCardProductPage = function (container) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		return productPage?.hasAttribute('data-gift-card') === true;
	};

	window.__krownIsGiftCardCartItem = function (item) {
		return item?.hasAttribute?.('data-gift-card') === true;
	};

	window.__krownGetVariantInventoryFromCartItem = function (item) {
		if (!item || window.__krownIsGiftCardCartItem(item)) return null;
		const management = item.dataset.inventoryManagement;
		const policy = item.dataset.inventoryPolicy;
		if (!management || policy === 'continue') return null;
		if (typeof item.dataset.inventoryQuantity === 'undefined') return null;
		const stock = parseInt(item.dataset.inventoryQuantity, 10);
		return Number.isFinite(stock) ? Math.max(0, stock) : null;
	};

	window.__krownGetSiblingVariantQtyInForm = function (form, variantId, excludeItemKey) {
		let total = 0;
		if (!form || !variantId) return total;
		form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
			if (String(el.dataset.variantId) !== String(variantId)) return;
			if (excludeItemKey && el.dataset.id === excludeItemKey) return;
			const q = parseInt(el.querySelector('.qty')?.value || el.dataset.qty, 10);
			if (Number.isFinite(q)) total += q;
		});
		return total;
	};

	window.__krownGetMaxQtyForCartLineInventory = function (form, item) {
		const stockLimit = window.__krownGetVariantInventoryFromCartItem(item);
		if (stockLimit == null) return null;
		const otherQty = window.__krownGetSiblingVariantQtyInForm(
			form,
			item?.dataset?.variantId,
			item?.dataset?.id
		);
		return Math.max(0, stockLimit - otherQty);
	};

	window.__krownGetVariantInventoryFromPage = function (productPage) {
		const el = productPage?.querySelector?.('[data-js-variant-quantity-data]');
		if (!el) return null;
		try {
			const data = JSON.parse(el.getAttribute('data-inventory') || '[]');
			return data?.[0] || null;
		} catch (_) {
			return null;
		}
	};

	window.__krownGetAvailabilityStockLimit = function (productPage) {
		if (window.__krownIsGiftCardProductPage(productPage)) return null;
		const variant = window.__krownGetVariantInventoryFromPage(productPage);
		if (!variant || variant.inventory === 'continue' || typeof variant.quantity === 'undefined') {
			return null;
		}
		const stock = parseInt(variant.quantity, 10);
		return Number.isFinite(stock) ? Math.max(0, stock) : null;
	};

	window.__krownFetchCartQtyForProduct = async function (productId) {
		if (!productId || typeof KROWN === 'undefined') return 0;
		try {
			const res = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
				headers: { Accept: 'application/json' },
				cache: 'no-store',
			});
			const cart = await res.json();
			return (cart.items || []).reduce((total, item) => {
				return String(item.product_id) === String(productId) ? total + item.quantity : total;
			}, 0);
		} catch (_) {
			return 0;
		}
	};

	window.__krownFetchCartQtyForVariant = async function (variantId) {
		if (!variantId || typeof KROWN === 'undefined') return 0;
		try {
			const res = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
				headers: { Accept: 'application/json' },
				cache: 'no-store',
			});
			const cart = await res.json();
			return (cart.items || []).reduce((total, item) => {
				return String(item.variant_id) === String(variantId) ? total + item.quantity : total;
			}, 0);
		} catch (_) {
			return 0;
		}
	};

	window.__krownCreateQtyLimitAlert = function (message) {
		const alert = document.createElement('div');
		alert.classList.add('alert', 'alert--error', 'alert--qty-limit');
		alert.setAttribute('role', 'alert');
		alert.textContent = message;
		return alert;
	};

	window.__krownClearProductQtyLimitAlert = function (container, itemEl) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		productPage?.querySelectorAll('[data-js-product-form-alert-host]').forEach((host) => {
			host.innerHTML = '';
		});
		container?.querySelectorAll('.alert--qty-limit').forEach((el) => el.remove());
		container
			?.closest?.('product-form')
			?.querySelectorAll('.alert--qty-limit')
			.forEach((el) => el.remove());
		document.getElementById('product-page-form-error-cart-alert')?.remove();
		itemEl?.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
	};

	window.__krownPlaceProductPageAlert = function (container, alertEl) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		const productForm =
			container?.closest?.('product-form') ||
			container?.querySelector?.('product-form') ||
			(productPage?.querySelector?.('product-form') ?? null);

		if (window.__krownIsGiftCardProductPage(container)) {
			const host =
				productForm?.querySelector('[data-js-product-form-alert-host]') ||
				productPage?.querySelector('[data-js-product-form-alert-host]');
			if (host) {
				host.innerHTML = '';
				host.hidden = false;
				host.removeAttribute('hidden');
				host.appendChild(alertEl);
				alertEl.id = 'product-page-form-error-cart-alert';
				alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				return;
			}
			const cartFunctions = productForm?.querySelector('.product__cart-functions');
			if (cartFunctions) {
				cartFunctions.appendChild(alertEl);
				alertEl.id = 'product-page-form-error-cart-alert';
				alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				return;
			}
		}

		const hostEl = productForm || container;
		alertEl.id = 'product-page-form-error-cart-alert';
		hostEl.prepend(alertEl);
		alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
	};

	window.__krownShowProductQtyLimitAlert = function (container, productId, itemEl, options) {
		options = options || {};
		let message = options.message || '';

		if (!message && options.scenario) {
			message = window.__krownResolveStockMessage(options.scenario, {
				ruleMax: options.ruleMax ?? window.__krownGetProductQtyLimit(productId),
				stockLimit: options.inventoryQuantity ?? options.stockLimit,
			});
		}
		if (!message && options.qtyAdded != null) {
			const stockLimit =
				options.inventoryQuantity ??
				options.stockLimit ??
				window.__krownGetAvailabilityStockLimit?.(container);
			const ruleMax = options.ruleMax ?? window.__krownGetProductQtyLimit(productId);
			if (stockLimit != null || ruleMax != null) {
				message = window.__krownResolveStockMessage('partial_add', { ruleMax, stockLimit });
			} else {
				message = window.__krownGetAvailabilityAddedMessage(options.qtyAdded);
			}
		}
		if (!message && window.__krownIsProductCardContext(container)) {
			const stockLimit =
				options.stockLimit ?? window.__krownGetAvailabilityStockLimit?.(container);
			const ruleMax = options.ruleMax ?? window.__krownGetProductQtyLimit(productId);
			message = window.__krownResolveStockMessage('cart_at_cap', { ruleMax, stockLimit });
		}
		if (!message) {
			message = window.__krownGetProductQtyLimitMessage(productId);
		}
		if (!message) return;

		if (container && !itemEl) {
			window.__krownClearProductQtyLimitAlert(container);
			const alert = window.__krownCreateQtyLimitAlert(message);
			if (options.id) {
				alert.id = options.id;
			}
			window.__krownPlaceProductPageAlert(container, alert);
		}

		if (itemEl) {
			itemEl.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
			const inline = window.__krownCreateQtyLimitAlert(message);
			inline.classList.add('cart-item__qty-limit-notice', 'text-size--small');
			const host =
				itemEl.querySelector('.cart-item__actions') ||
				itemEl.querySelector('.cart-form-item__actions') ||
				itemEl;
			host.appendChild(inline);
		}

		if (container && itemEl) {
			container.querySelectorAll('.alert--qty-limit').forEach((el) => el.remove());
			const formAlert = window.__krownCreateQtyLimitAlert(message);
			container.prepend(formAlert);
		}
	};

	window.__krownGetSiblingProductQtyInForm = function (form, productId, excludeItemKey) {
		let total = 0;
		if (!form || !productId) return total;
		form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
			if (String(el.dataset.productId) !== String(productId)) return;
			if (excludeItemKey && el.dataset.id === excludeItemKey) return;
			const q = parseInt(el.querySelector('.qty')?.value || el.dataset.qty, 10);
			if (Number.isFinite(q)) total += q;
		});
		return total;
	};

	window.__krownGetMaxQtyForCartLine = function (form, item) {
		let max = null;

		const hardLimit = window.__krownGetProductQtyLimit(item?.dataset?.productId);
		if (hardLimit != null) {
			const otherQty = window.__krownGetSiblingProductQtyInForm(
				form,
				item.dataset.productId,
				item.dataset.id
			);
			max = Math.max(0, hardLimit - otherQty);
		}

		const invMax = window.__krownGetMaxQtyForCartLineInventory(form, item);
		if (invMax != null) {
			max = max == null ? invMax : Math.min(max, invMax);
		}

		return max;
	};

	window.__krownClampCartItemQty = function (form, item, qty) {
		if (qty === 0) return qty;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine == null) return qty;
		if (maxForLine <= 0) {
			return parseInt(item.dataset.qty, 10) || parseInt(item.querySelector('.qty')?.value, 10) || 1;
		}
		return Math.min(Math.max(0, qty), maxForLine);
	};

	window.__krownRefreshProductQtyLimitsInForm = function (form) {
		if (!form) return;
		form.querySelectorAll('[data-js-cart-item]').forEach((item) => {
			if (item.classList.contains('cart-item--freebie')) return;
			const qtyInput = item.querySelector('.qty');
			if (!qtyInput) return;
			window.__krownApplyProductQtyLimitToInput(form, item, qtyInput);
		});
	};

	window.__krownApplyProductQtyLimitToInput = function (form, item, qtyInput) {
		if (!qtyInput) return;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine == null) return;
		if (maxForLine > 0) {
			qtyInput.setAttribute('max', String(maxForLine));
			const current = parseInt(qtyInput.value, 10);
			if (Number.isFinite(current) && current > maxForLine) {
				qtyInput.value = maxForLine;
			}
		} else {
			qtyInput.setAttribute('max', '0');
		}
	};

	window.__krownGetCartLineLimitMessage = function (form, item) {
		const productId = item?.dataset?.productId;
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		const stockLimit = window.__krownGetVariantInventoryFromCartItem(item);
		if (stockLimit != null || hardLimit != null) {
			return window.__krownResolveStockMessage('cart_at_cap', {
				ruleMax: hardLimit,
				stockLimit,
			});
		}
		return window.__krownGetProductQtyLimitMessage(productId);
	};

	window.__krownShowCartLineLimitAlert = function (form, item) {
		const message = window.__krownGetCartLineLimitMessage(form, item);
		if (!message) return;
		window.__krownShowProductQtyLimitAlert(form, item?.dataset?.productId, item, { message });
	};

	window.__krownGetMaxAddableQtyOnProductPage = async function (productPage, productId, variantId, requestedQty) {
		const requested = parseInt(requestedQty, 10) || 1;
		let maxAddable = requested;

		const hardLimit = window.__krownGetProductQtyLimit(productId);
		if (hardLimit != null) {
			const cartProductQty = await window.__krownFetchCartQtyForProduct(productId);
			maxAddable = Math.min(maxAddable, Math.max(0, hardLimit - cartProductQty));
		}

		const stockLimit = window.__krownGetAvailabilityStockLimit(productPage);
		if (stockLimit != null && variantId) {
			const cartVariantQty = await window.__krownFetchCartQtyForVariant(variantId);
			maxAddable = Math.min(maxAddable, Math.max(0, stockLimit - cartVariantQty));
		}

		return maxAddable;
	};
})();
